import {
  FIXED_STEP_HZ,
  FIXED_STEP_MS,
  MAX_FRAME_DELTA_MS,
  MAX_STEP_DISPLACEMENT_RATIO,
  MAX_SUBSTEPS,
} from '../../config/gameplay';

const BASE_MATTER_DELTA_MS = 1_000 / 60;

export const MATTER_RUNNER_CONFIG = {
  fps: FIXED_STEP_HZ,
  frameDeltaSmoothing: false,
  frameDeltaSnapping: false,
  maxUpdates: MAX_SUBSTEPS,
  maxFrameTime: MAX_FRAME_DELTA_MS,
} as const;

export function maxMatterSpeedForThickness(minimumThickness: number): number {
  if (!Number.isFinite(minimumThickness) || minimumThickness <= 0) {
    throw new RangeError('minimumThickness must be positive');
  }
  const maximumStepDisplacement = minimumThickness * MAX_STEP_DISPLACEMENT_RATIO;
  return maximumStepDisplacement * (BASE_MATTER_DELTA_MS / FIXED_STEP_MS);
}

export function physicalStepDisplacement(matterSpeed: number): number {
  return matterSpeed * (FIXED_STEP_MS / BASE_MATTER_DELTA_MS);
}
